const { queryFirst, queryAll, addClass, removeClass } = require('./domUtil');
const { HIDDEN_CLASS } = require('./constants');

document.addEventListener('DOMContentLoaded', () => {
    const loadMoreBtn = queryFirst('.all-store-events-list .btn-load-more');
    loadMoreBtn.addEventListener('click', () => {
        removeClass(queryAll('.all-store-events-list li'), HIDDEN_CLASS);
        addClass(loadMoreBtn, HIDDEN_CLASS);
    });
});
